<div class="custom-dialog">
  <div class="custom-dialog-header">
    <h3>About Update</h3>
    <ion-text color="dark-pink">{{updateInfo.currentVersion}}</ion-text>
  </div>
  <div class="custom-dialog-body">
    <ol class="list-decimal space-y-4">
      @for (update of updateInfo.updates; track update) {
        <li>
          {{update}}
        </li>
      }
    </ol>
  </div>
  <ion-button expand="full" color="dark-pink" fill="clear" shape="round"
    class="font-semibold border-t border-gray-200/70 ion-text-capitalize !m-0 text-lg h-14"
    (click)="updateApp()">Update
  </ion-button>
</div>
